/* eslint-disable */
import config from '../config'
import axios from 'axios'

const instance = axios.create({
  baseURL: `${config.API_URL}/api/`,
})

export default instance
